import { useQuery } from "@tanstack/react-query";
import CommonService from "../services/CommonService";

export const useContainerDeliveryMethods = () => {
    return useQuery({
        queryKey: ["containerDeliveryMethods"],
        queryFn: () => CommonService.getAllContainerDeliveryMethods().then(res => res.data),
        staleTime: Infinity,
        cacheTime: Infinity,
        placeholderData: (prevData) => prevData
    });
};